import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import StepOne from './step-one';
import StepTwo from './step-two';
import StepThree from './step-three';
import { useRouter } from 'next/navigation';
import { format } from 'date-fns';
import axios from 'axios';


const MultiStepFormSelf = (props) => {
 
    const [currentStep, setCurrentStep] = useState(1);
    const router = useRouter();
    const form = useForm({
        defaultValues: {
            name: '',
            email: '',
            phone: '',
            city: '',
            state:'',
            pincode:'',
            location:'',
            speciality:'',
            doctor:'',
            date:null
            
        },
    });

    const handleNextStep = () => {
        setCurrentStep((prevStep) => prevStep + 1);
    };

    const handlePreviousStep = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    };


    const onSubmit = async (data) => {
        // console.log(data,'frr')
        
        const inputDate = new Date(data.date);
        const utcDate = new Date(inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000));
        const convertedDate = utcDate.toISOString();

        try {

            const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}/appointments?locale=${props.lang}`; // Strapi API endpoint
        

            const patientsData = {
                patientName: data.name,
                patientEmail: data.email,
                patientPhone: data.phone,
                patientCity: data.city,
                patientState: data.state,
                patientPincode: data.pincode,
                appointmentDateSelected: convertedDate,
                selfAppointment: true,
                locationSelected: data.location,
                doctorSelected: data.doctor,
                specialitySelected: data.speciality,
                schedulerName: "itsMe",
                source:"Website",
                formName:"Book an Appointment Form",
            };
            // Strapi API endpoint
            try {
                const response = await axios.post(apiUrl, { data: patientsData }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    const responseData = response.data;
                    // console.log(responseData);
                    // alert('Strapi Success:itsMeMobile'+ responseData);
                } else {
                    console.error('Failed to submit form');
                }
            } catch (error) {
                console.error('Error:', error);
            }
           


            // Clear the form after submission
            form.reset();
            // router.push('/book/thank-you')
            if (props.lang) {
                router.push(`/${props.lang}/book/thank-you`);
              } else {
                router.push('/book/thank-you');
              }
        } catch (error) {
            console.error('Error:', error);
        }
    };


    return (
        
        <>
      
            <FormProvider {...form}>
                {currentStep === 1 && <StepOne onNextStep={handleNextStep} appointmentBooking={props.appointmentBooking}/>}
                {currentStep === 2 && (
                    <StepTwo onPreviousStep={handlePreviousStep} onNextStep={handleNextStep} appointmentBooking={props.appointmentBooking}/>
                )}
                {currentStep === 3 && (
                    <StepThree onPreviousStep={handlePreviousStep} onSubmit={form.handleSubmit(onSubmit)} appointmentBooking={props.appointmentBooking} lang={props.lang}/>
                )}
            </FormProvider>
        
        
        </>
        
    );
};


export default MultiStepFormSelf;
